import React from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import App from './App'
import '../src/index.css'
import { queryClient } from '@/lib/queryClient'
import { AuthProvider } from '@/contexts/AuthContext'
import { AppProvider } from '@/contexts/AppContext'
import { ThreatCatProvider } from '@/contexts/ThreatCatContext'
import { ProjectProvider } from '@/contexts/ProjectContext'
import { QuestionsProvider } from '@/contexts/QuestionsContext'
import { TooltipProvider } from '@/components/ui/tooltip'

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AppProvider>
        <QuestionsProvider>
          <AuthProvider>
            <ThreatCatProvider>
              <ProjectProvider>
                <TooltipProvider delayDuration={300}>
                  <App />
                </TooltipProvider>
              </ProjectProvider>
            </ThreatCatProvider>
          </AuthProvider>
        </QuestionsProvider>
      </AppProvider>
    </QueryClientProvider>
  </React.StrictMode>
)
